import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WA_URL =
  "https://wa.me/18763555819?text=" +
  encodeURIComponent("Hi BEC Couriers! I'd like to ask about shipping.");

export const WhatsAppButton = () => (
  <motion.a
    data-testid="whatsapp-chat-button"
    href={WA_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with BEC Couriers on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.5, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center border border-white/20 shadow-[0_8px_30px_rgba(37,211,102,0.35)]"
  >
    <span
      className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"
      aria-hidden="true"
    />
    <MessageCircle className="relative w-6 h-6" fill="currentColor" />
  </motion.a>
);
